<template>
  <div>
    正在登录统一门户
  </div>
</template>
<script>
/* eslint-disable */
import * as dd from 'dingtalk-jsapi'

export default {
  data () {
    return {
      titleName: '',
      agentId: '',
      appId: '',
    }
  },
  watch: {
    '$route': {
      handler () {
        this.weixin()
      },
      deep: true
    }
  },
  created () {
    this.initData()
  },
  mounted () {
    // this.dindin()
  },
  methods: {
    weixin () {
      let redirectUri = encodeURIComponent(window.location.origin + '/sso/weiXin/autoLoginByCode?fromType=mobile')
      // let redirectUri = encodeURIComponent('http://dlcd.laomaocy.com/sso/dingDing/autoLoginByCode?fromType=mobile')
      // console.log(redirectUri)
      window.location.href =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+this.appId+'&redirect_uri='+redirectUri+'&response_type=code&scope=snsapi_privateinfo&state=STATE&agentid='+this.agentId+'#wechat_redirect'
    },
    initData () {
      let param = window.location.search ? window.location.search + '&type=dingding' : '?type=dingding'
      this.$request.post('/sso/backgroundSet/findUsedBgSet').then(res => {
        const { code, data } = res.data
        const settingLogin = res.data.extra
        if (code === 'OK') {
          this.agentId = settingLogin.weixin.agentid
          this.appId = settingLogin.weixin.appid
          this.weixin()
        }
      }).catch((err) => {
        console.log(err)
      })
    },
  }
}
</script>
